
import documentVersions from '../../config/documentVersions.json';
import { PathwayFormatter } from '../PathwayFormatter';
import { PathwayReferenceHelper } from '../PathwayReferenceHelper';
import { ACCBISTPathwayReference } from './ACCBIST-PathwayReference';
import { FormLoader } from '../FormLoader';
import { ENVIRONMENT } from '../../config/config';
import { redux } from '../../components/App';
import { calculateEWS, TotalEWS  } from './Custom Types/EWS';
import { CalculationModel } from './Custom Types/CalculationModel';
import { ACCBISTCalculationHelper } from './Helpers/ACCBISTCalculationHelper';

const sectionLine = '=======================================\n';
const sectionBreak = '\n\n';

export class ACCBISTFormatter {
    static formatAsPlainText(workflow) {
        var forms = [
            FormLoader.form(workflow.pathwayUuid, 'patientDetailsSubform'),
            FormLoader.form(workflow.pathwayUuid, 'injuryDetailsSubform'),
            FormLoader.form(workflow.pathwayUuid, 'clinicalAssessmentSubform'),
            FormLoader.form(workflow.pathwayUuid, 'awptaCheck1Subform'),
            FormLoader.form(workflow.pathwayUuid, 'awptaCheck2Subform'),
            FormLoader.form(workflow.pathwayUuid, 'awptaCheck3Subform'),
            FormLoader.form(workflow.pathwayUuid, 'awptaCheck4Subform'),
            FormLoader.form(workflow.pathwayUuid, 'awptaCheck5Subform'),
            FormLoader.form(workflow.pathwayUuid, 'bistSymptomScale'),
            FormLoader.form(workflow.pathwayUuid, 'gcsSubform'),
            FormLoader.form(workflow.pathwayUuid, 'vitalSignsSubform'),
            FormLoader.form(workflow.pathwayUuid, 'ctBrainSubform'),
            FormLoader.form(workflow.pathwayUuid, 'resultsForm')
        ];

        var formattedString = '';

        for (let form of forms) {
            let details = form.detailString(false);
            if (details != null && details != undefined) {
                formattedString += form.title.toUpperCase() + '\n';
                formattedString += sectionLine;
                formattedString += details;
                formattedString += sectionBreak;
            }
        }

        formattedString += 'INSIGHTS\n';
        formattedString += sectionLine;
        formattedString += 'A-WPTA Score: ' + getCalculationBadge(workflow, CalculationModel.CalculationType.awptaScoreCalculation, 'awptaScoreCalculation') + '\n';
        formattedString += sectionBreak;
        formattedString += 'BIST Score: ' + getCalculationBadge(workflow, CalculationModel.CalculationType.bistScoreCalculation, 'bistScoreCalculation') + '\n';
        formattedString += sectionBreak;
        formattedString += 'BIST Dominant Cluster: ' + getCalculationBadge(workflow, CalculationModel.CalculationType.bistDominantSymptomCluster, 'bistDominiantSymptomCluster') + '\n';
        formattedString += sectionBreak;
        formattedString += 'Concussion Risk Category: ' + getCalculationBadge(workflow, CalculationModel.CalculationType.concussionRiskCategory, 'concussionRiskCategory') + '\n';
        formattedString += sectionBreak;

        formattedString += 'DIAGNOSIS\n';
        formattedString += sectionLine;
        formattedString += (FormLoader.form(workflow.pathwayUuid, 'resultsForm')).getPlainTextActions(false, ['diagnosisConcussionAction', 'diagnosisConcussionConfoudningFactorsAction']);

        formattedString += 'INVESTIGATIONS\n';
        formattedString += sectionLine;
        formattedString += (FormLoader.form(workflow.pathwayUuid, 'resultsForm')).getPlainTextActions(false, ['ctHead']);

        formattedString += 'MANAGEMENT\n';
        formattedString += sectionLine;
        formattedString += (FormLoader.form(workflow.pathwayUuid, 'resultsForm')).getPlainTextActions(false, ['seniorMedicalReview', 'seekNeuroscienceReview', 'neuroObsManagement']);

        formattedString += 'DISCHARGE PLAN\n';
        formattedString += sectionLine;
        formattedString += (FormLoader.form(workflow.pathwayUuid, 'resultsForm')).getPlainTextActions(false, ['accReferralLowRiskAction', 'accReferralModerateRiskAction', 'physioTherapistReferralAction']);

        let noteDetails = (FormLoader.form(workflow.pathwayUuid, 'notesForm')).detailString(false);
        if (noteDetails != null && noteDetails != undefined) {
            formattedString += 'NOTES\n';
            formattedString += sectionLine;
            formattedString += noteDetails;
            formattedString += sectionBreak;
        }
        
        return formattedString;
    }
}

function getEmptyValue(identifier){
    let reference = PathwayReferenceHelper.reference(identifier, ACCBISTPathwayReference.data);
    return '[' + reference.title + ']';
}

function getCalculationBadge(workflow, calculationType, identifier) {
    let mainForm = FormLoader.form(workflow.pathwayUuid, 'mainForm');
    let error = ACCBISTCalculationHelper.calcualtionError(identifier, workflow.rawData, mainForm);
    
    if(error != null){
        return error.message;
    }

    let pathwayProgress = mainForm.completionProgress();
    if(pathwayProgress == null) {
        return getEmptyValue(identifier);
    }

    let calculations = redux.store.getState().calculationReducer.calculations['accbist01'];

    let calculation = ACCBISTCalculationHelper.getLatestCalculation(calculationType, calculations);

    if (calculation == null) { return getEmptyValue(identifier); }

    calculation = CalculationModel.rehydrate(calculation);

    return calculation.valueString + (calculation.rating != null ? ' (' + calculation.rating + ')' : '');
}

function getEnvironmentName() {
    switch (ENVIRONMENT) {
        case 'PROD':
            break;
        case 'DEV':
            return 'Dev ';
        case 'TEST':
            return 'Test ';
        case 'STAGING':
            return 'Staging ';
        case 'DEMO':
            return 'Demo ';
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/ACCBIST-Formatter.js